import ListenerEvents from "@/utils/listener-events";
import StatsigEvents from "@/utils/statsig-events";
import Log from "@/utils/Log";

const list_events: {[key: string]: ((data: any, key: string) => void)[]} = {};

const prevent_multi_trigger: string[] = [];

class Events{
    constructor(historic_events: ((event: Events) => void)[] = []) {
        if(Array.isArray(historic_events)){
            historic_events.forEach(callback => {
                if(typeof callback === "function"){
                    this.push(callback);
                }
            })
        }
    }

    static push(callback: (event: Events) => void, event: Events|undefined = undefined): void{
        if(typeof callback === "function"){
            callback(event ?? new Events());
        }
    }

    push(callback: (event: Events) => void): void{
        return Events.push(callback, this);
    }

    static trigger(key: string, data: any = undefined): void{
        if(!prevent_multi_trigger.includes(key)){
            data = typeof data === "object" ? data : {};
            if(!Array.isArray(data)){
                data.key = key;
            }
            Log.log("trigger_event:", key, data);
            prevent_multi_trigger.push(key);
            if(list_events.hasOwnProperty(key)){
                list_events[key].forEach(callback => {
                    callback(data, key);
                });
            }

            if(list_events.hasOwnProperty("*")){
                list_events["*"].forEach(callback => {
                    callback(data, key);
                });
            }
        }

        setTimeout(() => {
            let i = prevent_multi_trigger.indexOf(key);
            if (i !== -1) {
                prevent_multi_trigger.splice(i, 1);
            }
        } , 1000)
    }

    trigger(key: string, data: any = undefined): void{
        return Events.trigger(key, data);
    }

    static addEventListener(key: string|string[], callback: (data: any, key: string) => void): void{
        if(Array.isArray(key)){
            key.forEach(item => this.addEventListener(item, callback));
        }else{
            if(!list_events.hasOwnProperty(key)){
                list_events[key] = [];
            }
            
            list_events[key].push(callback);
        }
    }

    addEventListener(key: string|string[], callback: (data: any, key: string) => void): void{
        return Events.addEventListener(key, callback);
    }

    static sendHotjarEvent(action_name: string): void{
        //@ts-ignore
        if (typeof window !== "undefined" && window.hj && typeof window.hj === "function") {
            //@ts-ignore
            window.hj('event', action_name)
        }
    }

    sendHotjarEvent(action_name: string): void{
        Events.sendHotjarEvent(action_name);
    }
}

export const InitLoadEvents = (): void => {
    //@ts-ignore
    window.dataLayerAssineEstadao = []
    //@ts-ignore
    if(typeof window !== "undefined" && !(window.ASSINE_EVENTS instanceof Events)){
        //@ts-ignore
        window.ASSINE_EVENTS = new Events(window.ASSINE_EVENTS || [])
        //@ts-ignore
        ListenerEvents(window.ASSINE_EVENTS);
        //@ts-ignore
        StatsigEvents(window.ASSINE_EVENTS);

        const urlParams = new URLSearchParams(window.location.search);
        Log.active = !!urlParams.get('debug');

        window.addEventListener('error',function(e){
            Log.sendApm({
                message: e.message,
                error: e.error instanceof Error ? {
                    message: e.error.message,
                    name: e.error.name,
                    stack: e.error.stack,
                    cause: e.error.cause
                } : null,
                colno: e.colno,
                line: e.lineno,
                file: e.filename
            });
        });
    }
}

export default Events;